/**
 * Linguist - web page translator
 *
 * Declares a single web-accessible-resource: `contentscript.css`, matched to every
 * origin with no `use_dynamic_url` — so the one injected stylesheet is fetchable from
 * any page at a fixed URL.
 *
 * With only one WAR and no bundled icons, detection rests on that single vendor path;
 * it is served only when the extension is installed, which makes it conclusive.
 *
 * Manifest verified against version 7.0.5.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gbefmodhlophhakmoecijeppjblibmie';

export const linguist: ExtensionDefinition = {
  id: ID,
  name: 'Linguist - web page translator',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Exposes a single static WAR (contentscript.css) to every origin with no dynamic ' +
    'URL. Detection is one fetch and conclusive.',
  signals: [
    {
      id: 'war-contentscript-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch contentscript.css — the only web-accessible resource, exposed to every ' +
        'origin and served only when the extension is installed.',
      weight: 1,
      run: () => probeFetch(ID, 'contentscript.css'),
    },
  ],
};
